<script lang="typescript">
    import { Promotion } from "./types";
    import { fade } from "svelte/transition";

    export let promotion: Promotion | null;
</script>

{#if promotion == Promotion.EYECARE_PLAN}
    <section
        class="
    w-full
    items-end
    justify-center
    text-primary
  absolute
  bottom-0
    flex"
    >
        <div class=" z-35 w-full text-lg p-4 opacity-95" transition:fade={{ duration: 200 }}>
            <div class="ml-8 mr-4 mt-4 text-black">
                <h2>Features & benefits</h2>
                <ul class="">
                    <li>20% discount</li>
                    <li>Accidental breakage & loss protection (optional)</li>
                    <li>Free routine eye tests</li>
                    <li>Free reglaze</li>
                    <li>Free 100 day returns guarantee</li>
                    <li>Free lifetime servicing</li>
                </ul>
            </div>
        </div>
    </section>
{/if}

<style>
    p {
        @apply mt-2;
    }
</style>
